import React from "react";

import { percentage } from "lib/common";

import { threadResultsType } from "lib/store/dashboard";

import "./DashboardThreadDetail.scss";

type DashboardThreadDetailProps = {
  data: threadResultsType;
};

export const DashboardThreadDetail: React.FC<DashboardThreadDetailProps> = ({
  data,
}) => {
  const { plain_text, result } = data;
  return (
    <div className={`DashboardThreadDetail`}>
      <span className={"percent"}>
        {result?.sentiment} {percentage(result?.sentiment_score, 0)}%
      </span>
      <div className="text-wrapper">
        <p>{plain_text}</p>
      </div>
    </div>
  );
};
